export const MODAL_TYPE_ALERT = 'ALERT';
export const MODAL_TYPE_INFO = 'INFO';
export const MODAL_TYPE_OK = 'OK';
export const MODAL_TYPE_WARNING = 'WARNING';
export const MODAL_TYPE_NO_BUTTON = 'NO_BUTTON';
